module.exports = __webpack_public_path__ + "img/table1-en.63b963c8.svg";